module.exports = __webpack_public_path__ + "img/linux-hero.670b0247.webp";